import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-help',
  templateUrl: './page-help.component.html',
  styleUrls: ['./page-help.component.sass']
})
export class PageHelpComponent implements OnInit {

  coverPhoto: string = "./assets/img/cover.png";

  constructor() { }

  ngOnInit(): void {
  }

}
